import Image from "next/image";

import { useMemo, useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

import { twMerge } from "tailwind-merge";

const downloadIcon = require("assets/download.svg");

export default function ToolMnaTransactionsDownload({
  onExportCSV,
  onExportPDF,
  onExportPNG,
  isLoading,
}: {
  onExportCSV?: () => void;
  onExportPDF?: () => void;
  onExportPNG?: () => void;
  isLoading?: boolean;
}) {
  const [show, setShow] = useState(false);

  const exportOptions = useMemo(() => {
    return [
      ...(onExportPNG
        ? [
            {
              id: "PNG",
              label: "Image",
              onClick: onExportPNG,
            },
          ]
        : []),
      ...(onExportCSV
        ? [
            {
              id: "CSV",
              label: "CSV",
              onClick: onExportCSV,
            },
          ]
        : []),
      ...(onExportPDF
        ? [
            {
              id: "PDF",
              label: "PDF",
              onClick: onExportPDF,
            },
          ]
        : []),
    ];
  }, [onExportCSV, onExportPDF, onExportPNG]);

  const button = useMemo(() => {
    return (
      <button
        className={twMerge(
          "hidden md:flex items-center justify-center gap-[10px] px-[15px] z-10 cursor-pointer h-[35px]",
          "border-0 rounded-full bg-smart-teal transition-all hover:bg-dark-teal text-white",
          "shadow-[1px_3px_3px_0_rgb(0_0_0_/_30%)]",
          isLoading ? "opacity-50 !cursor-not-allowed" : ""
        )}
        onMouseEnter={() => setShow(true)}
        id="download-button"
      >
        <Image
          src={downloadIcon}
          alt="download"
          className="w-[13px] h-[13px] object-contain mt-[-2px]"
        />
        Export
      </button>
    );
  }, [isLoading]);

  if (isLoading) {
    return button;
  }

  return (
    <OverlayTrigger
      placement={isLoading ? "top" : "left-start"}
      show={show}
      trigger={isLoading ? "hover" : "click"}
      rootClose
      onToggle={(show) => setShow(show)}
      overlay={
        <Popover className="z-[999999]" onMouseLeave={() => setShow(false)}>
          <Popover.Body className={"p-0 py-[4px]"}>
            {exportOptions.map((option: any) => {
              return (
                <div
                  key={option.id}
                  className="flex text-[15px] space-x-[5px] p-[13px] cursor-pointer hover:bg-smart-teal hover:text-white"
                  onClick={option.onClick}
                >
                  {option.label}
                </div>
              );
            })}
          </Popover.Body>
        </Popover>
      }
    >
      {button}
    </OverlayTrigger>
  );
}
